<template>
    <el-dialog
        title="账号已封禁"
        :visible.sync="banInfo.isBan"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :center="true"
        width="30%">
        <div style="text-align: center;">{{banInfo.reason}}</div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" plain size="small" @click="loginOut">退出登录</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import { loginOut } from 'Services/getData.js';
export default {
    computed: {
        ...mapGetters([
            'banInfo'
        ])
    },
    methods: {
        async loginOut(){
            let res = await loginOut();
            if(res.data.code == 0){
                location.href=`${document.location.protocol}//${document.location.hostname}`;
            }
        }
    }
}
</script>
